exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-3856e7d0] .v-label {\n  padding-top: 0.25rem !important;\n}\n", ""]);

// exports
